import { TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledHeaderTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#fafaff",
  borderRight: "1px solid #ebebf7",
  borderColor: "#ebebf7",
  fontSize: 12,
  lineHeight: "15px",
  padding: 2,
  position: "sticky",
  zIndex: 2,

  [theme.breakpoints.up("xxl")]: {
    fontSize: 14,
    lineHeight: "18px",
    padding: 2,
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderRight: "1px solid #ebebf7",
  borderColor: "#ebebf7",
  fontSize: 12,
  lineHeight: "15px",
  padding: 2,

  [theme.breakpoints.up("xxl")]: {
    fontSize: 14,
    lineHeight: "18px",
    padding: 2,
  },
}));
